import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import DocumentForm from './DocumentForm'

import { storeDocument } from '../services'

export default function NewDocumentModal({ visible, onClose, reload }) {

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Agregar Registro</ModalHeader>
				<ModalBody>
					<DocumentForm 
						apiService={storeDocument}
						onSuccess={() => {
							message.success('Documento agregado correctamente')
							reload()
							onClose()
						}}
					/>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}